import(/* webpackMode: "eager" */ "/opt/gdocnext_dev/app/template.tsx");
